<template lang="pug">
div
  v-form(ref="form")
    v-row(no-gutters)
      v-col(:cols="blast.enabled ? 12 : 7")
        v-card.rounded-lg.content-box.pa-6(outlined)
          v-row
            v-col(:cols="blast.enabled ? 7 : 12")
              v-row
                v-col.grow
                  div.d-flex.align-center
                    .text-md.font-semibold Email delivery
                    y-chip.ml-2(v-if="blastData && blast.enabled && checkPaused(blastData)" label="Paused" color="red")
                v-col.shrink(v-if="blastData && blast.enabled && checkPaused(blastData)")
                  y-button(label="Resolve" outlined size="xxs" @click="showResolveDialog = true")
                v-col.shrink
                  y-switch.mb-n3(v-model="blast.enabled")

              v-row.my-4(v-if="blast.enabled")
                v-divider.neutral300

              template(v-if="blast.enabled")
                //- Email subject line
                div.text-md.font-semibold.neutral700--text.mt-5 Email subject line
                v-text-field.text-sm.mt-2.round-xl(v-model="blast.subject" placeholder="Enter email subject line here" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
                div.text-xs.neutral500--text.ml-3.mt-2 The email subject line is only used when sending email
                //- Email preview text
                div.text-md.font-semibold.neutral700--text.mt-5 Email preview text
                v-text-field.text-sm.mt-2.round-xl(v-model="blast.preview_text" placeholder="Enter email notification preview line" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
                div.text-xs.neutral500--text.ml-3.mt-2 This text will appear in the inbox after the subject line

            v-divider.neutral300.my-n3(v-if="blast.enabled" vertical)
            //- Email preview
            v-col.py-0(v-if="blast.enabled" cols="5")
              email-preview(:subject-line="blast.subject" :notification-preview-line="blast.preview_text")

          template(v-if="blast.enabled")
            v-row.mt-6
              v-divider.neutral300
            //- Email content
            div.text-md.font-semibold.neutral700--text.mt-6 Offers email content
            page-editor.mt-3.mx-(v-if="showFroala" :parentForm.sync="blast.content")
            div.text-sm.font-semibold.neutral700--text.mt-5 Insert field:
            div.d-flex.align-center.mt-1
              v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('offer_name')")
                span.neutral700--text Offer details
              v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('recipient_name')")
                span.neutral700--text Customer name
              v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('company_name')")
                span.neutral700--text Clinic’s name
              v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('company_phone')")
                span.neutral700--text Phone number
              template(v-if="offer.redeem_method != 'show_message'")
                v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('offer_code')")
                  span.neutral700--text Promo code
              v-chip.mr-3(v-if="offer.end_after_value && offer.end_after_unit" link small outlined color="neutral400" @click="insertValue('expiry_date')")
                span.neutral700--text Expiry date
  .dialogs
    resolve-paused-preset-dialog(v-if="showResolveDialog" :open.sync="showResolveDialog" :preset="preset" :blast="blastData" @updated="$emit('resolved')")

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import PageEditor from '@/components/clinic/PageEditor.vue'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import EmailPreview from '@/components/clinic/marketing/EmailPreview.vue'
import ResolvePausedPresetDialog from '@/components/clinic/marketing/dialogs/ResolvePausedPresetDialog.vue'

export default {
  components: { PageEditor, DatePickerField, EmailPreview, ResolvePausedPresetDialog },
  props: {
    blastData: {
      type: Object,
      default: null
    },
    sendDelaySelection: {
      type: Object,
      default: () => {
        return {
          timeValue: 1,
          timeUnit: 'hours'
        }
      }
    }
  },
  data() {
    return {
      isFetching: false,
      showFroala: false,
      showResolveDialog: false,
      blast: {
        name: 'Offer message',
        send_cue: 'preset',
        type: 'offer',
        method: 'email',
        enabled: false,
      },
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      offer: 'marketing/getOffer'
    }),
    preset () {
      return this.offer.name.toLowerCase()
    },
  },
  mounted() {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData() {
      this.$nextTick(() => {
        this.showFroala = true
      })
      if (this.blastData) {
        this.blast = JSON.parse(JSON.stringify(this.blastData))
      }
    },
    insertValue(value) {
      let text = ''
      const code = `{{ ${value} }}`
      if (this.blast.content) {
        text = `${this.blast.content} ${code}`
      } else {
        text = code
      }
      this.$set(this.blast, 'content', text)
    },
    validateData() {
      return this.$refs.form.validate()
    },
    saveData() {
      if (!this.validateData()) {
        return
      }
      if (!this.blastData && !this.blast.enabled) {
        return
      }
      const payload = this.getPayload()
      if (this.blast.id) {
        return this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${this.blast.id}`, payload)
      }
      return this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`, payload)
    },
    getAutoSendDelayPayload(payload) {
      if (this.offer.name === 'First purchase' || this.offer.name === 'Second purchase') {
        payload.send_cue = 'auto_send_delay'
        payload.auto_send_delay_time_value = this.sendDelaySelection.timeValue
        payload.auto_send_delay_time_unit = this.sendDelaySelection.timeUnit
        payload.auto_send_delay_specific_time = this.sendDelaySelection.specificTime
      }
      return payload
    },
    getPayload() {
      if (!this.blast.enabled) {
        let payloadBlastDisabled = {
          enabled: false
        }
        payloadBlastDisabled = this.getAutoSendDelayPayload(payloadBlastDisabled)
        return payloadBlastDisabled
      }
      let payloadBlastEnabled = {
        enabled: true,
        name: this.blast.name,
        method: this.blast.method,
        type: this.blast.type,
        preview_text: this.blast.preview_text,
        subject: this.blast.subject,
        content: this.blast.content,
        send_cue: this.blast.send_cue,
        schedules: [],
      }
      payloadBlastEnabled = this.getAutoSendDelayPayload(payloadBlastEnabled)
      return payloadBlastEnabled
    },
    checkPaused (data) {
      let paused = false
      if (data.schedules.find(f => f.status === 'paused')) {
        paused = true
      }
      return paused
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }

  .error--text {
    color: var(--v-danger500) !important;

    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>